import settings from './settings';
import axios from 'axios';

export async function getUserStructures(accessToken) {
  return axios.get(settings.endpoints.getUserStructures(), {
    headers: {
      Authorization: accessToken
    }
  })
}

export async function getDashboardStructures(accessToken, structureId, filter){
  return axios.get(settings.endpoints.getDashboardStructure(structureId),{
    params: filter,
    headers: {
      Authorization: accessToken
    }
  })
}

export async function getStructure(accessToken, structureId, filter) {
  return axios.get(settings.endpoints.getStructure(structureId), {
    params: filter,
    headers: {
      Authorization: accessToken
    }
  })
}

export async function postInviteToStructure(accessToken, structureId, data){
  return axios.post(settings.endpoints.postInviteToStructure(structureId),  data,{
    headers: {
      Authorization: accessToken
    }
  })
}

export async function updateStructure(accessToken, structureId, data){
  return axios.post(settings.endpoints.updateStructure(structureId), data, {
    headers: {
      Authorization: accessToken
    }
  })
}

export async function getStructureDetails(accessToken, structureId){
  return axios.get(settings.endpoints.structureDetails(structureId), {
    headers: {
      Authorization: accessToken
    }
  })
}
